<template>
  <div class="seeMoreWrapper">
    <!-- <div class="seeMore" @click.stop="onClk">
      <span>查看全部</span>
      <z-icon class-prefix="zziconfont-6" name="arrow" />
    </div> -->
    <!-- v-if="foldUp !== 0" -->
    <div
      zz-sectionid="115"
      :zz-sortid="foldUp === 2 ? 0 : 1"
      :zz-sortname="foldUp === 2 ? '折叠' : '展开全部'"
      class="show-btn"
      :class="{ isShowFull: foldUp === 2 }"
      @click="showClick"
    >
      <span>
        {{ foldUp === 2 ? '折叠' : '展开更多' }}
      </span>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue'
import { defineComponent, onMounted, ref } from '@vue/composition-api'
import SmoothScroll from '@utils/smoothScroll'
import { Icon } from '@zz-common/zz-ui'
import { isPlatform } from '@utils/native'

Vue.use(Icon)
;(window as any).SmoothScroll = SmoothScroll

export default defineComponent({
  components: {},
  props: {
    onClkSeeMore: Function,
    goodsInfo: {
      type: Object as any,
      default: () => {}
    }
  },
  setup(props) {
    const foldUp = ref(1) // 0：默认平铺  1：收缩  2：展开

    /**
     * $ 元素滚动到指定位置动画效果
     * # params:{ statusHeight 状态栏高度 elem滚动的目标元素 }
     */
    // TODO: 二奢融合 元素滚动
    const smoothScrollToElement = (params) => {
      const { statusHeight, elem } = params
      let offsetValue = 0
      let dom_height: number = 0
      if (isPlatform('zz')) {
        const _H = document.querySelector('.header-content') as HTMLElement
        offsetValue = Math.ceil(
          Number(_H.clientHeight) + Number(_H.offsetTop) + Number(statusHeight)
        )
      } else {
        dom_height = (80 / 750) * window.innerWidth
        offsetValue = Math.ceil(Number(dom_height) + Number(statusHeight))
      }
      const smoothScroll = new (window as any).SmoothScroll(null, {
        offset: offsetValue,
        updateURL: false
      })

      smoothScroll.animateScroll(elem)
    }

    /**
     * $ 二奢融合 商品介绍展开收起
     */
    // TODO: 二奢融合 商品介绍展开 收起
    const showClick = () => {
      if (foldUp.value === 1) {
        foldUp.value = 2
      } else {
        foldUp.value = 1
      }
      // props.onClkSeeMore(foldUp.value)
      ;(props.onClkSeeMore as (any) => void)(foldUp.value)
      if (foldUp.value == 1) {
        const elem: HTMLElement = document.querySelector('#tab-goodsIntro') as HTMLElement
        elem && smoothScrollToElement({ statusHeight: props.goodsInfo.statusHeight, elem })
      }
    }

    onMounted(() => {
      // do same things...
    })

    return {
      showClick,
      foldUp
    }
  }
})
</script>
<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
@import '@zz-common/zz-ui/lib/style/mixins/ellipsis.scss';
.seeMoreWrapper {
  padding-top: 32px;
}
.show-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 12px;
  color: #999;
  font-size: 24px;
  letter-spacing: 0;
  text-align: center;

  span {
    position: relative;
    display: inline-block;
    padding-bottom: 3px;
    color: #111;
    font-weight: 300;
    font-size: 24px;
    font-family: PingFangSC-Light, PingFang SC;
    line-height: 1;
    &::after {
      @include hairline(#111);
      border-bottom-width: 1px;
    }
  }
}

.isShowFull {
  img {
    margin-top: 4px;
    transform: rotate(-180deg);
  }
}
.max-wrap {
  max-height: 2200px;
  overflow: hidden;
}
</style>
